import { render } from "./EditProduct.vue?vue&type=template&id=c4b384b6&scoped=true&ts=true"
import script from "./EditProduct.vue?vue&type=script&lang=ts"
export * from "./EditProduct.vue?vue&type=script&lang=ts"

import "./EditProduct.vue?vue&type=style&index=0&id=c4b384b6&lang=css"
import "./EditProduct.vue?vue&type=style&index=1&id=c4b384b6&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b384b6"]])

export default __exports__